export const PAGE_VISITED = 'Visited Page';
export const NEW_PROJECT = 'Clicked New Project';
export const FILE_REVIEW = 'Completed File Review';
export const ADD_CHART = 'Clicked “+ Chart”';
export const DELETE_MULTI_CHART = 'Deleted Multi-chart';
export const DELETE_SINGLE_CHART = 'Deleted Single-chart';
export const DOWNLOAD_CHART = 'Downloaded a Chart';
export const CLICKED_SHARE_CHART = 'Clicked Share Chart';
export const SHARE_CHART = 'Shared a Chart';
export const SHARE_CHART_LINK_COPIED = 'Copied chart link';
export const CLICKED_SHARE_PROJECT = 'Clicked Share Project';
export const SHARE_PROJECT = 'Shared a Project';
export const SHARE_PROJECT_LINK_COPIED = 'Copied project link';
export const EDIT_CHART_CLICKED = 'Clicked Edit chart';
export const CHANGE_CHART_TYPE = 'Changed Chart Type ';
export const CHANGE_CHART_OPERATION = 'Changed Chart Operation Type';
export const CHANGE_Y_AXIS = 'Changed Chart Y axis';
export const CHANGE_X_AXIS = 'Changed Chart X axis';
export const CHANGE_SPLIT_BY = 'Select/Change Split By';
export const LEAVE_CHART_COMMENT = 'Leave a Comment';
export const BACK_TO_PROJECT = 'Go Back to Project';
export const CLICKED_MY_PROJECTS = 'Go to My Projects';
export const DELETE_PROJECT = 'Deleted a Project';
export const SUBMIT_FEEDBACK = 'Submitted Support';
export const CLICKED_KNOW_MORE = 'Clicked Know More link';
export const CHANGED_THEME = 'Changed Color Palette';
export const CHANGED_DATE_INTERVAL_GROUP = 'Changed Date Interval (Group)';
export const REMOVED_DATE_INTERVAL_GROUP = 'Removed Date Interval (Group)';
export const REPORT_DOWNLOADED = 'Report Downloaded';
export const INFO_SENSITIVE = 'Info: Sensitive';
export const CLICKED_SETTINGS = 'Clicked View Settings';
export const SELECT_SORT_ORDER = 'Select sort order';
export const CHANGE_STACKING = 'Change Stacking';
export const ADD_A_FILTER = 'Add a Filter';
export const CLICKED_TABLE_ICON = 'Viewed chart as Table';
export const UPLOADED_FILE = 'Uploaded File';
export const SIGNED_IN = 'Signed In';
export const CLICKED_FEEDBACK = 'Clicked Support';
export const CLICKED_HELP = 'Clicked Help';
export const CLICKED_DOWNLOAD_REPORT = 'Clicked Download Report';
export const CLICKED_DOWNLOAD_TABLE = 'Download Table';
export const CLICKED_VIEW_CLEANED_DATA = 'Clicked View Cleaned data';
export const SELECT_TOP_X = 'Select Top X';
export const SELECT_BOTTOM_X = 'Select Bottom X';
export const CLICKED_FILTER = 'Clicked Filter';
export const SET_GRADIENT = 'Set Gradient';
export const SET_MULTI_COLOUR = 'Set Multi Colour';
export const SET_3D = 'Set 3D';
export const CLICKED_THEME = 'Clicked Theme';
export const CLICKED_LOGOUT = 'Clicked Logout';
export const PAGE_NOT_FOUND = 'Got a 404 Error';
export const CLICKED_EMPTY_TRASH = 'Clicked Empty Trash';
export const EMPTIED_TRASH = 'Emptied Trash';
export const CHANGED_CHART_NAME = 'Changed Chart Name';
export const ADDED_CHART_LONG_DESCRIPTION = 'Added Chart Long Description';
export const ADDED_CHART_SHORT_DESCRIPTION = 'Added Chart Short Description';
export const CHANGED_PROJECT_NAME = 'Changed Project Name';
export const ADDED_PROJECT_LONG_DESCRIPTION = 'Added Project Long Description';
export const ADDED_PROJECT_SHORT_DESCRIPTION =
  'Added Project Short Description';
export const CLICKED_DOWNLOAD_CLEANED_FILE = 'Clicked Download cleaned file';
export const DOWNLOADED_CLEANED_FILE = 'Downloaded cleaned file';
export const CLICKED_DOWNLOAD = 'Clicked Download';
export const CLICKED_NOTIFICATION = 'Clicked Notification';
export const CLICKED_ADD_METER = 'Clicked Add Meter';
export const ADDED_METER = 'Added Meter';
export const CLICKED_DS_RECOMMENDATION = 'Clicked DataSquirrel Recommendation';
export const CLICKED_AUTO_CATEGORIZATION = 'Clicked Auto Categorization';
export const SUBMIT_AUTO_CATEGORIZATION = 'Submitted Auto Categorization';
export const AUTO_CATEGORIZATION_SUCCESS = 'Success: Auto Categorization';
export const AUTO_CATEGORIZATION_FAILED = 'Failure: Auto Categorization';
export const API_ERROR = 'Api Error Occurred';
export const REMOVED_NUMBER_INTERVAL = 'Removed Number Interval';
export const AUTO_FLIPPED_AXIS = 'Auto flipped axis';
export const REPOSITION_CHART = 'Reposition Chart';
export const RESIZED_CHART = 'Resized Chart';
export const CLICKED_REGISTER = 'Clicked Register';
export const SIGN_IN_ATTEMPT = 'Sign in attempt';
export const VIEW_CHART = 'View Chart';
export const VIEW_PROJECT_BOARD = 'View Project Board';
export const VISITED_SIGN_IN_PAGE = 'Visited Sign In page';
export const CHART_RENDER_SUCCESS = 'Chart rendered successfully';
export const CHART_BOARD_RENDER_SUCCESS = 'Chart board rendered successfully';
export const SIGN_IN_ERROR_INCORRECT_DETAILS =
  'Sign-in Error: Incorrect details';
export const SIGN_IN_ERROR_NOT_VERIFIED = 'Sign-in Error: Not Verified';
export const SIGN_IN_ERROR_NO_CLASSIFICATION =
  'Sign-in Error: No classification';
export const CLICKED_DASHBOARD_FILTER = 'Clicked Dashboard Filter';
export const ADDED_DASHBOARD_FILTER = 'Added Dashboard Filter';
export const CLICKED_CHART_FILTER = 'Clicked Chart Filter';
export const ADDED_CHART_FILTER = 'Added Chart Filter';
export const REMOVED_DASHBOARD_FILTER = 'Removed Dashboard Filter';
export const REMOVED_CHART_FILTER = 'Removed Chart Filter';
export const CLICKED_UPGRADE_PLAN = 'Clicked_Upgrade_Plan';
export const SHOWED_PAYMENT_REQUIRED = 'Showed_Payment_Required';
export const CLICKED_FORGOT_PASSWORD = 'Clicked Forgot Password';
export const CLICKED_ADD_DATA = 'clicked_add_data';
export const CLICKED_COMBINE_DATA = 'clicked_combine_data';
export const CLICKED_IMPORT_NEW_FILE = 'clicked_import_new_file';
export const CLICKED_SELF_CLEAN = 'clicked_self_clean';
export const CLICKED_AUTO_CLEAN = 'clicked_auto_clean';
export const CLOSED_VIEW_SETTINGS = 'Closed View Settings';
export const CLICKED_CONNECT_GOOGLE_SHEET = 'clicked_connect_google_sheet';
export const CLICKED_READ_CLIPBOARD = 'clicked_read_clipboard';
export const ERROR_API_FILE_SIZE_LIMIT = 'ERROR: App_File_size_limit';
export const ERROR_UNSUPPORTED_FORMAT = 'ERROR: Unsupported_format';
export const CLICKED_NUMBER_INTERVAL = 'clicked_number_interval';
export const CLICKED_SHOW_EMPTY_VALUES = 'clicked_show_empty_values';
export const INPUT_SQUIRREL_BOT = 'input_SqB_prompt';
export const CLICKED_AUTO_AI = 'clicked_auto_ai';
export const VISITED_MY_PROJECTS_PAGE = 'visited_my_projects_page';
export const VISITED_REVIEW_PAGE = 'visited_review_page';
export const VISITED_PROJECT_BOARD = 'visited_project_board';
export const VISITED_EDIT_CHART_PAGE = 'visited_edit_chart_page';
export const SELECTED_A_SHEET = 'selected_a_sheet';
export const CLICKED_CHART_UPVOTE = 'clicked_chart_upvote';
export const CLICKED_CHART_DOWNVOTE = 'clicked_chart_downvote';
export const REMOVED_VOTE = 'removed_vote';
export const CLICKED_REMOVE_WATERMARK = 'clicked_remove_watermark';
export const ADDED_HEATMAP = 'added_heatmap';
export const REMOVED_HEATMAP = 'removed_heatmap';
export const CLICKED_SQBOT_UPVOTE = 'clicked_SqB_upvote';
export const CLICKED_SQBOT_DOWNVOTE = 'clicked_SqB_downvote';
export const CLICKED_REFRESH_DATA = 'clicked_update_data';
export const CONFIRM_REFRESH_DATA = 'confirm_update_data';
export const CANCEL_REFRESH_DATA = 'cancel_update_data';
export const SUBMITTED_GOOGLE_SHEET_LINK = 'submitted_g-sheet_link';
export const CHANGED_ANONYMISATION_STATUS = 'changed_anonymise_status';
export const DOWNLOADED_ON_LOCAL = 'downloaded_on_local';
export const INITIATED_CHART_REPOSITION = 'intiated_chart_reposition';
export const ADDED_DATE_FILTER = 'added_date_filter';
export const CLICKED_DATE_FILTER_ICON = 'clicked_date_filter_icon';
export const CLICKED_CHART_AREA = 'clicked_chart_area';
export const CONNECT_GOOGLE_SHEET = 'G-Sheet_Connected';
export const CLICKED_SOCIALS = 'clicked_socials';
export const USED_SQUIRBY = 'used_Squirby';
export const CLICKED_SHOW_INSIGHT = 'clicked_show_insight';
export const CLICKED_INSIGHT_UPVOTE = 'clicked_insight_upvote';
export const CLICKED_INSIGHT_DOWNVOTE = 'clicked_insight_downvote';
export const CLICKED_ADD_AS_DESCRIPTION = 'clicked_add_as_description';
export const CLICKED_CONNECT_DATA = 'clicked_connect_data';
export const CLICKED_BANNER = 'Clicked_Banner';
export const CLICKED_SHOW_AS_PERCENTAGE_TOGGLE = 'show_as_%';
export const CLICKED_EXPLAINER_VIDEO = 'clicked_explainer_video';
